/* In/cm toggle for the per-product garment measurement chart
   (snippets/product-garment-measurements.liquid). The chosen unit is set on
   the element and CSS shows the matching values. */
if (!customElements.get('garment-measurements')) {
  customElements.define(
    'garment-measurements',
    class GarmentMeasurements extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-unit-input]')) {
            this.dataset.unit = event.target.value;
          }
        });
      }
    }
  );
}
